import { MobiDocument } from './MobiDocument';

export class LabelLienDocument extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private lien: string;

    public constructor(labelLien: any) {
        super()
        this._id = labelLien._id;
        this._rev = labelLien._rev;
        this.id = labelLien.id;
        this.lien = labelLien.lien
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getLien(): string {
        return this.lien;
    }

    public setLien(lien: string): void {
        this.lien = lien;
    }


}